import React from 'react';
// eslint-disable-next-line no-unused-vars
import ReactDOM from 'react-dom';
import DisplayPanel from '../reusableComponents/displayPanel';
import 'whatwg-fetch';

class LocationForm extends React.Component {
  componentWillMount() {
    this.props.updatePanelState({
      error: '',
      heading: 'Create new Location',
      subHeading: '',
      path1: 'Location',
      path2: 'Create',
    });
    this.state = {};
  }

  componentDidMount() {
    this.setState({ submitDisabled: false });
  }

  render() {
    return (
      <section className='panel'>
        <header className='panel-heading'>
          <div className='panel-actions'>
            <a href='#' className='panel-action panel-action-toggle' data-panel-toggle></a>
          </div>

          <h2 className='panel-title'>Create Location</h2>
        </header>
        <div className='panel-body'>
          <form
            className='form-horizontal form-bordered'
            onSubmit={event => this.locationSubmit(event)}
          >
            <div className='form-group'>
              <label className='col-md-3 control-label' htmlFor='inputDefault'>
                Name
              </label>
              <div className='col-md-6'>
                <input
                  type='text'
                  className='form-control'
                  id='inputDefault'
                  required
                  ref={name => {
                    this.name = name;
                  }}
                  minLength={1}
                  maxLength={50}
                />
              </div>
            </div>

            <div className='form-group'>
              <label className='col-md-3 control-label' htmlFor='inputDefault'>
                Barcode
              </label>
              <div className='col-md-6'>
                <input
                  type='text'
                  className='form-control'
                  id='inputDefault'
                  required
                  ref={barcode => {
                    this.barcode = barcode;
                  }}
                  minLength={3}
                  maxLength={50}
                />
              </div>
            </div>
            <div className='form-group'>
              <label className='col-md-3 control-label' htmlFor='inputSuccess'></label>
              <div className='col-md-6'>
                <button
                  type='submit'
                  className='btn btn-lg btn-success btn-block'
                  disabled={this.state.submitDisabled}
                >
                  <span> Create</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
    );
  }

  locationSubmit(event) {
    const self = this;
    event.preventDefault();
    this.setState({ submitDisabled: true });

    const name = this.name.value;
    const barcode = this.barcode.value;

    const token = localStorage.getItem('jwt');
    const head = new Headers();
    head.append('Content-Type', 'application/json');
    head.append('Authorization', token);

    const json = {
      name,
      barcode,
    };
    fetch('/api/Locations/create', { method: 'POST', headers: head, body: JSON.stringify(json) })
      .then(response => {
        if (response.status === 401) {
          this.setState({ token: '' });
          localStorage.removeItem('jwt');
          window.location = '/login';
        }
        if (response.status !== 200) {
          self.props.updatePanelState({
            error: `There was a problem. Status Code: ${response.status}`,
          });
          self.setState({ submitDisabled: false });
          return;
        }
        response.json().then(data => {
          if (!data.success) {
            self.props.updatePanelState({ error: data.message, successMsg: '' });
          } else {
            self.props.updatePanelState({ successMsg: data.message, error: '' });
          }
        });
        self.setState({ submitDisabled: false });
      })
      .catch(err => {
        self.props.updatePanelState({ error: err.message, successMsg: '' });
        self.setState({ submitDisabled: false });
      });
  }
}

export default class LocationPage extends React.Component {
  render() {
    return (
      <DisplayPanel>
        <LocationForm />
      </DisplayPanel>
    );
  }
}
